
/**
 * Hydration Admin Logger
 * 
 * Buffer privato module-scoped per errori di hydration.
 * - Gli errori vengono bufferizzati silenziosamente (nessun output in console)
 * - Se l'utente è admin, vengono flushati in console
 * - Se non è admin, vengono scartati silenziosamente
 * - Se il flag __HYDRATION_DEBUG__ è attivo, questo modulo NON viene usato
 *   (gli errori vengono loggati direttamente in entry-client.tsx)
 * 
 * @see .lovable/plan.md per il piano completo
 */

interface HydrationErrorEntry {
  route: string;
  message: string;
  componentStack: string | null;
  timestamp: number;
}

// Buffer privato: non accessibile da console, window o DevTools
let buffer: HydrationErrorEntry[] = [];

/**
 * Salva un errore di hydration nel buffer privato.
 * Nessun output in console, nessuna traccia su window.
 */
export function bufferHydrationError(entry: HydrationErrorEntry): void {
  buffer.push(entry);
}

/**
 * Flush: logga tutti gli errori bufferizzati in console e svuota il buffer.
 * Chiamato solo quando l'utente è confermato admin.
 * Se __HYDRATION_DEBUG__ è attivo, non fa nulla (gli errori sono già stati loggati).
 */
export function flushHydrationErrorsForAdmin(): void {
  if (typeof window !== 'undefined' && (window as any).__HYDRATION_DEBUG__) return;
  if (buffer.length === 0) return;

  console.warn(`[HYDRATION] ${buffer.length} recoverable error(s) captured during hydration:`);
  buffer.forEach((e, i) => {
    console.warn(
      `[HYDRATION][${i + 1}] route=${e.route}`,
      '\n  message:', e.message,
      '\n  componentStack:', e.componentStack || '(n/a)'
    );
  });
  buffer = [];
}

/**
 * Discard: svuota silenziosamente il buffer senza alcun output.
 * Chiamato quando l'utente NON è admin.
 */
export function discardHydrationErrors(): void {
  buffer = [];
}
